import {
  APP_DISCLAIMER_TYPES,
  AppLoginMethods,
  LOCIZE_ERRORS_TRANSLATION_KEYS,
  LOCIZE_LOGIN_TRANSLATION_KEYS,
  LocizeNamespaces,
  PageAttributeNames,
} from 'app-constants';
import { AppDisclaimer } from 'components';
import { DisclaimerNotification } from 'components/notification';
import { Typography } from 'components/typography';
import { Button } from 'components/ui/button';
import type { VisiblePageAttributes } from 'models';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface LoginButton {
  label: string;
  method: AppLoginMethods;
  [key: string]: any;
}

interface LoginViewContentProps {
  loginButtons?: LoginButton[];
  selectedLoginMethod: AppLoginMethods;
  isLoginFlowWithError: boolean;
  visiblePageAttributes: VisiblePageAttributes;
  loginFormsMap: Record<string, FC<any>>;
  styles: {
    buttons?: string;
    form?: string;
  };
  headingTranslationKey?: string;
}

export const LoginViewContent = ({
  loginButtons,
  selectedLoginMethod,
  isLoginFlowWithError,
  visiblePageAttributes,
  loginFormsMap,
  styles,
  headingTranslationKey = LOCIZE_LOGIN_TRANSLATION_KEYS.loginPageTitle,
}: LoginViewContentProps) => {
  const { t } = useTranslation(LocizeNamespaces.login);
  const { t: te } = useTranslation(LocizeNamespaces.errors);

  const loginPageHeading = t(headingTranslationKey);
  const errorTitle = te(
    LOCIZE_ERRORS_TRANSLATION_KEYS.authenticationErrorLabel,
  );

  const renderLoginMethodButtons = () =>
    loginButtons?.map(({ label, method, ...props }) => (
      <Button {...props} key={method}>
        {label}
      </Button>
    ));

  const LoginForm = loginFormsMap[selectedLoginMethod];

  return (
    <>
      <Typography variant="xs" className="text-center">
        {loginPageHeading}
      </Typography>
      <div className={styles.buttons}>{renderLoginMethodButtons()}</div>

      {visiblePageAttributes[PageAttributeNames.smartIdFullDisclaimer] &&
        selectedLoginMethod === AppLoginMethods.smartId && (
          <DisclaimerNotification className="mt-6">
            {t(LOCIZE_LOGIN_TRANSLATION_KEYS.smartIdFullVersionDisclaimer)}
          </DisclaimerNotification>
        )}

      <AppDisclaimer
        title={errorTitle}
        type={APP_DISCLAIMER_TYPES.error}
        visible={isLoginFlowWithError}
      />

      <div className={styles.form}>
        <LoginForm />
      </div>
    </>
  );
};
